import React from "react"
import dynamic from "next/dynamic"
import Loading from "@/components/common/Loading"

export const DOWNLOAD_FILES_VARIANTS = {
	DEFAULT: "default",
	SINGLE_NEWS: "single-news",
}

const DefaultVariant = dynamic(() => import("@/components/downloadFiles/variants/DefaultVariant"), {
	loading: () => <Loading />,
	ssr: false,
})

const SingleNewsVariant = dynamic(() => import("@/components/downloadFiles/variants/SingleNewsVariant"), {
	loading: () => <Loading />,
	ssr: false,
})

function VariantSwitcher({ variant, data, textColor }) {
	switch (variant) {
		case DOWNLOAD_FILES_VARIANTS.DEFAULT:
			return <DefaultVariant data={data} textColor={textColor} />
		case DOWNLOAD_FILES_VARIANTS.SINGLE_NEWS:
			return <SingleNewsVariant data={data} />
		default:
			return null
	}
}

const DownloadFiles = ({ data, textColor = "", variant = DOWNLOAD_FILES_VARIANTS.DEFAULT }) => {
	return <VariantSwitcher variant={variant} data={data} textColor={textColor} />
}

export default DownloadFiles
